module.exports = __webpack_public_path__ + "static/media/gps.18af4b67.svg";